import { GeneratedProductReleaseType } from '../../../types/generated';

export const resolveReleaseType = (
  releaseType?: GeneratedProductReleaseType | null,
) => {
  const isAuction = releaseType === GeneratedProductReleaseType.Auction;

  return {
    isAuction,
    isBuy:
      releaseType === GeneratedProductReleaseType.Public ||
      releaseType === GeneratedProductReleaseType.Private ||
      releaseType === GeneratedProductReleaseType.Timed,
    isDraw: isAuction || releaseType === GeneratedProductReleaseType.Draw,
  };
};
